import { privateClient } from '../apiClient';
import { DEMO_USER } from '../../mocks/auth/authMocks';

class UserService {
    private useMock = import.meta.env.VITE_USE_MOCK === 'true';

    async fetchProfile() {
        if (this.useMock) return DEMO_USER;
        const response = await privateClient.get('/user/profile');
        return response.data;
    }

    async updateProfile(data: { first_name: string, last_name: string, phone: string }) {
        if (this.useMock) return { ...DEMO_USER, ...data };
        const response = await privateClient.put('/user/profile', data);
        return response.data;
    }

    async updatePassword(currentPassword: string, newPassword: string) {
        if (this.useMock) return { success: true };
        const response = await privateClient.put('/user/password', {
            current_password: currentPassword,
            new_password: newPassword,
        });
        return response.data;
    }

    async updateNotifications(emailNotifications: boolean) {
        if (this.useMock) return { success: true };
        const response = await privateClient.put('/user/notifications', {
            email_notifications: emailNotifications,
        });
        return response.data;
    }
}

export default new UserService();